import {Injectable} from '@angular/core';
import {Gtag} from 'angular-gtag';

declare let ga: Function; // Declare ga as a function

@Injectable()
export class GoogleAnalyticsService {

  constructor(private gtag: Gtag) {
  }


  // create our event emitter to send our data to Google Analytics
  public eventEmitter(eventCategory: string,
                      eventAction: string,
                      eventLabel: string = null,
                      eventValue: number = null) {
    ga('send', 'event', {
      eventCategory: eventCategory,
      eventLabel: eventLabel,
      eventAction: eventAction,
      eventValue: eventValue
    });
  }

  public emitCustomEventGoogleAnalytics(eventAction, eventLabel, eventCategory, eventUser) {
    this.gtag.event(eventAction, { event_label: eventLabel, event_category: eventCategory,  value: eventUser});
  }
}
